export const TYPE_KEYS = {
  GUEST: 'GUEST',
  FREE: 'FREE',
  PAID: 'PAID',
  APPROVED_USER: 'APPROVED_USER'
}
export const ROLE_KEYS = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
  ADVISOR: 'ADVISOR'
}
export const PACKAGE_KEYS = {
  BUYER_STANDARD: 'BUY STANDARD',
  BUYER_PREMIUM: 'BUY PREMIUM',
  COMPANY_STANDARD: 'COMPANY STANDARD',
  COMPANY: 'COMPANY',
  COMPANY_PREMIUM: 'COMPANY PREMIUM',
  LOAN: 'LOAN',
  FRANCHISE: 'FRANCHISE',
  SALES_PARTNERSHIP: 'SALES_PARTNERSHIP',
  BUSINESS_IDEA: 'BUSINESS_IDEA',
  ADVISOR: 'ADVISOR',
  BUYER: 'BUYER'
}
export const ACTION_KEYS = {
  // Guest
  ACCESS_DETAIL_PROFILE_BASIC: 'ACCESS_DETAIL_PROFILE_BASIC',
  NAVIGATE_CREATE_BUYER_SELLER: 'NAVIGATE_CREATE_BUYER_SELLER',

  // Free user
  ACCESS_DETAIL_PROFILE_LIMITED: 'ACCESS_DETAIL_PROFILE_LIMITED',
  VIEW_BUYER_SELLER_TAB: 'VIEW_BUYER_SELLER_TAB',
  VIEW_TRANSACTION_LIST: 'VIEW_TRANSACTION_LIST',
  VIEW_SUBSCRIPTION_LIST: 'VIEW_SUBSCRIPTION_LIST',
  VIEW_MESSAGING_UI: 'VIEW_MESSAGING_UI',

  // Paid
  ACCESS_DETAIL_PROFILE_WITH_REQUEST: 'ACCESS_DETAIL_PROFILE_WITH_REQUEST',
  VIEW_MESSAGING_UI_WITH_PENDING_APPROVAL: 'VIEW_MESSAGING_UI_WITH_PENDING_APPROVAL',

  // Approved
  ACCESS_FULL_DETAIL_PROFILE: 'ACCESS_FULL_DETAIL_PROFILE',
  OPEN_CHAT: 'OPEN_CHAT',

  // Creation
  CREATE_BUYER_PROFILE: 'CREATE_BUYER_PROFILE',
  CREATE_SELLER_PROFILE: 'CREATE_SELLER_PROFILE',
  CREATE_ADVISOR_PROFILE: 'CREATE_ADVISOR_PROFILE'
}

export const TAB_KNOWLEDGE = [
  {
    label: 'Guides & How-To',
    value: 'GUIDES'
  },
  {
    label: 'Research Report',
    value: 'RESEARCH_REPORT'
  }
]
